import {Collection} from "../collections/base";
import {purchase} from "./purchase";
import {BBModel} from "../bb_model";
import {OrderCollections} from "../collections/purchase_collections";
import {context} from "../constants/context";

const adminOrder = {
    query(prms) {

        let company;
        if (prms.company) {
            ({company} = prms);
            delete prms.company;
            prms.company_id = company.id;
        }
        return new Promise((resolve, reject) => {
            const existing = OrderCollections.find(prms);
            if (existing && !prms.skip_cache) {
                resolve(existing);
            } else if (company) {
                if (prms.skip_cache) {
                    if (existing) {
                        OrderCollections.delete(existing);
                    }
                    company.$flush('purchases', prms);
                }
                company.$get('purchases', prms).then((resource) => {
                        if (resource.$has('purchases')) {
                            resource.$get('purchases').then((orders) => {
                                    const models = (Array.from(orders).map(b => new BBModel.Admin.Order(b)));
                                    const items = new Collection.Order(resource, models, prms);
                                    OrderCollections.add(items);
                                    return resolve(items);
                                }
                                , err => reject(err));
                        } else {
                            const order = new BBModel.Admin.Order(resource);
                            return resolve(order);
                        }
                    }
                    , err => reject(err));
            } else {
                reject('No comapny passed in');
            }
        });
    },

    markAsPaid(params) {
        let company_id;
        return new Promise((resolve, reject) => {

            if (!params.order || !params.url_root) {
                reject('invalid request');
                return;
            }

            if (params.company) {
                company_id = params.company.id;
            }

            const uri = `${params.url_root}/api/${context.apiVersion}/admin/${company_id}/purchases/${params.purchase.id}/pay`;

            const data = {};
            if (params.company) {
                data.company_id = params.company.id;
            }
            if (params.notify_admin) {
                data.notify_admin = params.notify_admin;
            }
            if (params.payment_status) {
                data.payment_status = params.payment_status;
            }
            if (params.amount) {
                data.amount = params.amount;
            }
            if (params.notes) {
                data.notes = params.notes;
            }
            if (params.transaction_id) {
                data.transaction_id = params.transaction_id;
            }
            if (params.notify) {
                data.notify = params.notify;
            }
            if (params.payment_type) {
                data.payment_type = params.payment_type;
            }

            purchase.doPurchaseAPIAction('$put', uri, params, resolve, reject);
        });
    }
};

export {
    adminOrder
}
